"use strict";
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function getEmployees(list) {
    if (!list) return;
    var employeesList = _to_consumable_array(list.children).reduce(function(previous, item) {
        previous.push({
            name: item.textContent.trim(),
            position: item.dataset.position,
            salary: item.dataset.salary,
            age: item.dataset.age
        });
        return previous;
    }, []);
    return employeesList;
}
function sortList(employeesList, list) {
    var _loop = function(index) {
        list.append(_to_consumable_array(list.children).find(function(child) {
            return child.innerText === sortedList[index].name;
        }));
    };
    if (!list) return;
    function numberExtractor(number) {
        return Number(number.split("").filter(function(char) {
            return !isNaN(Number(char));
        }).join(""));
    }
    var sortedList = employeesList.sort(function(personOne, personTwo) {
        return numberExtractor(personTwo.salary) - numberExtractor(personOne.salary);
    });
    for(var index = 0; index < sortedList.length; index++)_loop(index);
}
var ulList = document.querySelector("ul");
var objectList = getEmployees(ulList);
sortList(objectList, ulList);

//# sourceMappingURL=index.1c180c42.js.map
